import { Builder, withChildren } from '@builder.io/react';
import Block from './block';
import theme from '../../gatsby-plugin-theme-ui-v1';

Builder.registerComponent(withChildren(Block), {
  name: 'Block',
  inputs: [
    {
      name: 'padding',
      type: 'string',
      enum: [...Object.keys(theme.space).filter((key) => key !== 'mega')],
      defaultValue: 'small',
      required: true,
    },
    {
      name: 'backgroundMedia',
      type: 'string',
      enum: ['none', 'image'],
      defaultValue: 'none',
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.keys(theme.backgroundColors),
      defaultValue: 'transparent',
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      required: false,
      showIf: (options) => options.get('backgroundMedia') === 'image',
    },
    {
      name: 'borderRadius',
      type: 'string',
      enum: ['card', 'none'],
      default: 'none',
      required: false,
    },
    {
      name: 'boxShadow',
      type: 'string',
      enum: ['card', 'none'],
      default: 'none',
      required: false,
    },
    {
      name: 'backgroundColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
    {
      name: 'textWidth',
      type: 'boolean',
      advanced: true,
      required: false,
      default: false,
      helperText: 'Limit Max Width to recommended reading length',
    },
    {
      name: 'justifyContent',
      type: 'string',
      enum: [
        'flex-start',
        'flex-end',
        'center',
        'space-between',
        'space-around',
        'space-evenly',
      ],
      defaultValue: 'center',
      required: true,
      advanced: true,
    },
    {
      name: 'alignItems',
      type: 'string',
      enum: ['stretch', 'flex-start', 'flex-end', 'center', 'baseline'],
      defaultValue: 'stretch',
      required: false,
      advanced: true,
    },
    {
      name: 'mediaObjectFit',
      type: 'string',
      advanced: true,
      enum: ['contain', 'cover', 'fill', 'none', 'scaled-down'],
      helperText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit',
      defaultValue: 'cover',
      required: false,
      showIf: (options) => options.get('backgroundMedia') !== 'none',
    },
    {
      name: 'mediaObjectPosition',
      type: 'string',
      advanced: true,
      helperText:
        'https://developer.mozilla.org/en-US/docs/Web/CSS/object-position',
      defaultValue: 'center',
      required: false,
      showIf: (options) => options.get('backgroundMedia') !== 'none',
    },
  ],
  // childRequirements: {
  //   message: 'You can only add Text, Images, Buttons, Custom Code, or Embeds to Blocks',
  //   query: {
  //     'component.name': {
  //       $in: [
  //         'Text',
  //         'Core:Button',
  //         'Buttons',
  //         'Image',
  //         'Table',
  //         'Embed Media',
  //         'Embed Custom',
  //         'Custom Code',
  //         'Columns',
  //       ],
  //     },
  //   },
  // },
  // defaultChildren: [
  //   {
  //     "@type": "@builder.io/sdk:Element",
  //     component: {
  //       name: "Text",
  //       options: {
  //         text: "Placeholder Text Goes Here",
  //         alignText: "Center",
  //       },
  //     },
  //   },
  // ],
});
